import { all, put, call, takeLatest } from '@redux-saga/core/effects';
import { JWT_REFRESH_TOKEN, JWT_TOKEN } from '../../constants/localStorage';
import { storeInSessionStorage } from '../../util/helpers/sessionStorageHelper';
import {
  AUTHENTICATE_SALES_ASSISTED,
  SALES_ASSISTED_APPLICATIONS_FETCH,
  SALES_ASSISTED_GET_INVITE_USER,
  SALES_ASSISTED_SEND_INVITE_USER,
  SALES_ASSISTED_SET_PASSWORD,
} from '../actions/salesAssisted/salesAssistedActionContants';
import {
  autheticateSaleAssistedUserSuccess,
  autheticateSaleAssistedUserError,
  fetchSalesAssistedApplicationsSuccess,
  fetchSalesAssistedApplicationsError,
  salesAssistedGetInviteUserSuccess,
  salesAssistedGetInviteUsersError,
  salesAssistedSendInviteUserSuccess,
  salesAssistedSendInviteUsersError,
  salesAssistedSetPasswordSuccess,
  salesAssistedSetPasswordError,
} from '../actions/salesAssisted/salesAsssistedActions';
import {
  authenticateSalesAssistedRequest,
  fetchSalesAssistedApplicationsRequiest,
  getUserInfoSalesAssistedRequiest,
  sendUserInviteSalesAssistedRequiest,
  setPasswordRequest,
} from '../../request/salesAssistedRequests';
import { addHeaderToken } from '../../request';
import { rejectErrorCodeHelper } from '../../util/helpers/rejectErrorCodeHelper';
import { formatErrorMessage } from '../../util/helpers/registerRejectErrorCodeHelper';

export function* autheticateSalesAssisted({ payload }) {
  try {
    const { data } = yield call(authenticateSalesAssistedRequest, payload.data);
    const { JwtToken, JwtRefreshToken } = data;
    if (JwtToken && JwtRefreshToken) {
      storeInSessionStorage(JWT_TOKEN, JwtToken);
      storeInSessionStorage(JWT_REFRESH_TOKEN, JwtRefreshToken);
      addHeaderToken(JwtToken);
    }
    yield put(autheticateSaleAssistedUserSuccess(data));
    yield put(autheticateSaleAssistedUserError(''));
    yield call(payload.onSuccess);
    return;
  } catch (error) {
    // eslint-disable-next-line no-console
    yield put(autheticateSaleAssistedUserError(error));
  }
}

export function* fetchSalesAssistedApplications({ payload }) {
  try {
    const { data } = yield call(
      fetchSalesAssistedApplicationsRequiest,
      payload.data,
    );
    yield call(payload.onSuccess, data);
    // yield call(onSuccess, JwtToken);
    yield put(fetchSalesAssistedApplicationsSuccess(data));
  } catch (error) {
    // eslint-disable-next-line no-console
    yield put(fetchSalesAssistedApplicationsError(error));
  }
}
export function* getInviteUserInfo({ payload }) {
  try {
    const { data } = yield call(getUserInfoSalesAssistedRequiest, payload.data);
    yield call(payload?.onSuccess, data);
    // yield call(onSuccess, JwtToken);
    yield put(salesAssistedGetInviteUserSuccess(data));
  } catch (error) {
    const errorMessage = formatErrorMessage(error);
    if (payload?.onError) {
      yield call(payload.onError, errorMessage);
    }
    // eslint-disable-next-line no-console
    yield put(salesAssistedGetInviteUsersError(error));
  }
}

export function* sendInviteUser({ payload }) {
  try {
    yield call(sendUserInviteSalesAssistedRequiest, payload.data);
    yield call(payload?.onSuccess);
    // yield call(onSuccess, JwtToken);
    yield put(salesAssistedSendInviteUserSuccess());
  } catch (error) {
    // eslint-disable-next-line no-console
    yield put(salesAssistedSendInviteUsersError(error));
  }
}
function* setPassword({ payload }) {
  try {
    yield call(setPasswordRequest, payload.data);
    yield put(salesAssistedSetPasswordSuccess(payload.data));
    yield put(salesAssistedSetPasswordError(''));
    yield call(payload?.handleSuccess, payload.data);
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield call(payload.handleError, errorMessage);
    yield put(salesAssistedSetPasswordError(errorMessage));
  }
}
export default function* salesAssisteSaga() {
  return yield all([
    takeLatest(AUTHENTICATE_SALES_ASSISTED, autheticateSalesAssisted),
    takeLatest(
      SALES_ASSISTED_APPLICATIONS_FETCH,
      fetchSalesAssistedApplications,
    ),
    takeLatest(SALES_ASSISTED_GET_INVITE_USER, getInviteUserInfo),
    takeLatest(SALES_ASSISTED_SEND_INVITE_USER, sendInviteUser),
    takeLatest(SALES_ASSISTED_SET_PASSWORD, setPassword),
  ]);
}
